import { render } from "./estimate2.vue?vue&type=template&id=664cfebe&scoped=true"
import script from "./estimate2.vue?vue&type=script&lang=js"
export * from "./estimate2.vue?vue&type=script&lang=js"

import "./estimate2.vue?vue&type=style&index=0&id=664cfebe&scoped=true&lang=css"

import exportComponent from "/home/withpd/git/geek9_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-664cfebe"]])

export default __exports__